export default __webpack_public_path__ + "static/media/register2.e10426b2.jpg";